export default "<ion-app>  \n  <ion-router-outlet Id=\"content\"></ion-router-outlet>  \n</ion-app>  ";